export default function getEnabledItems<T>(items: (T & { enabled?: boolean })[]) {
  return items
    .filter((item) => item.enabled || !('enabled' in item))
    .map(({ enabled: _enabled, ...rest }) => rest) as T[];
}
